<template>
  <el-row type="flex" class="topbar">
    <el-col :span="12">
      <div class="is-flex middle" v-if="showMenu">
        <div class="logo" @click="moveTo('home')">
          <transition
            :css="false"
            @beforeEnter="handleBeforeEnter"
            @enter="handleEnter"
            @leave="handleLeave"
          >
            <img :class="logo.class" :key="logo.name" :src="logo.src" alt="SodaLabs" />
          </transition>
        </div>
        <MenuTrigger />
      </div>
    </el-col>
    <el-col :span="12" class="is-flex middle end">
      <button
        v-if="showContactUs"
        @click="redirectTo({ name: 'contact' })"
        class="btn btn--primary btn--bounce text--18 is-demi-bold"
      >
        Contact us
      </button>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import MenuTrigger from './topbar/MenuTrigger.vue';

export default {
  components: {
    MenuTrigger,
  },
  data() {
    return {
      menuItems: [
        { label: 'Home', name: 'home' },
        { label: 'Vision', name: 'vision' },
        { label: 'Products', name: 'products' },
        { label: 'Team', name: 'team' },
        { label: 'Values', name: 'values' },
        { label: 'Careers', name: 'careers' },
      ],
    };
  },
  computed: {
    ...mapGetters(['logo', 'showContactUs', 'showMenu']),
  },
  methods: {
    ...mapMutations(['closeMenu']),
    redirectTo({ name }) {
      this.closeMenu();
      this.$router.push({ name });
    },
    moveTo(name) {
      if (this.$route.name !== 'index') {
        this.$router.push({ name: 'index', params: { silentTo: name } });
      } else {
        this.$root.$emit('menu-click', name);
      }
    },
    handleBeforeEnter(el) {
      el.style.opacity = 0;
    },
    handleEnter(el, done) {
      const delay = 100;
      setTimeout(() => {
        this.$Velocity(el, { opacity: 1 }, { complete: done });
      }, delay);
    },
    handleLeave(el, done) {
      const delay = 100;
      setTimeout(() => {
        this.$Velocity(el, { opacity: 0 }, { complete: done });
      }, delay);
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  position: absolute;
  width: 100%;
  z-index: 100;
  left: 0;
  top: 0;
  padding: 15px;
  @media (min-width: 1366px) {
    padding: 21px 32px 21px 16px;
  }
}
.logo,
.hamburger,
.btn-contact {
  position: relative;
  z-index: 101;
}
.logo {
  display: none;
  width: 105px;
  height: 60px;
  cursor: pointer;
  @media (min-width: 768px) {
    display: block;
  }
  img {
    position: absolute;
  }
}

.fadeIn-enter-active {
  animation: fadeIn 0.3s;
}

.fadeIn-leave-active {
  animation: fadeIn 0.3s reverse;
}
</style>
